var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cu-page__outer-block"},[_c('div',{staticClass:"campaign-edit-title"},[_c('h2',{staticClass:"h2-like"},[_vm._v(_vm._s(_vm.$t("dashboard.updates")))])]),_c('dashboard-updates')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }